// extracted by mini-css-extract-plugin
export default {"internalTaskCardDrawer__footer":"styles_internal-task-card-drawer__footer__Tr56V"};